{
  "comment": "The M3 stand-in career (M3 plan R5, §1.2), replaced by M2's career at the bridge. Credits, a hold in tonnes (partMassT per unit), part and scanner prices in credits (scanner keys are the Mk), and whether death loses the parts you carry (M2's death rule).",
  "startCredits": 15000,
  "capacityT": 20,
  "partMassT": { "hull_plating": 1, "electronics": 1, "drive_parts": 1 },
  "partPrices": { "hull_plating": 600, "electronics": 900, "drive_parts": 1200 },
  "scannerPrices": { "2": 10000, "3": 30000 },
  "deathLosesParts": true
}
